/* === BEGIN imported: modalPages/childSeatsDetails.jsx (verbatim from plugin, with phase-1 routing deviation) === */
import React from "react";
import {KeenSlider} from "../Components/keenSlider.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {useChildSeatTypes} from "@/hooks/useSelectables";

export function ChildSeatsDetails({setStep, closeModal}) {
    const {data: infantsCarSeat = []} = useChildSeatTypes();

    return (
        <>
            <ModalHeader
                title="Found right seat"
                extraClasses="first"
                totalSteps={0}
                cancelButton={false}
                backStep="passengerQuantity"
                showBackButton={true}
                setStep={setStep}
                closeModal={closeModal}
            />

            <div className="hopn-carseat-section modalPages-spacing pb-8 pr-0!">
                <KeenSlider items={infantsCarSeat} mobileItem="1.5" detailsView={true} itemNumber="2.5"/>
            </div>
        </>
    );
}

export default ChildSeatsDetails;
/* === END imported: modalPages/childSeatsDetails.jsx === */
